const usersRutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/users/LoginPage.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/users/UserRegisterPage.vue'),
  },
  {
    path: '/register/verificacion/:idUser',
    name: 'user-verificacion',
    component: () => import('../views/users/UserVerificacionPage.vue'),
  },
  {
    path: '/user/recover',
    name: 'user-recover',
    component: () => import('../views/users/UserRecoverPassword.vue'),
  },
]

export default usersRutes